module.exports = __webpack_public_path__ + "static/media/poster.e4bb8997.svg";